(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function FollowMeUtils() {}

/**
 * Creates a hash based on a string
 * Based on https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 *
 * @param {string} string
 * @static
 */
FollowMeUtils.hashString = function (string) {
  var hash = 0;
  var character;
  if (string.length === 0) return hash;
  for (var i = 0; i < string.length; i++) {
    character = string.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash &= hash; // Convert to 32bit integer
  }
  return hash;
};
module.exports = FollowMeUtils;

},{}],2:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var Importer = exports["default"] = /*#__PURE__*/_createClass(function Importer(fileName, fileData) {
  _classCallCheck(this, Importer);
  this._fileName = fileName;
  this._fileData = fileData;
});

},{}],3:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Importer2 = _interopRequireDefault(require("./Importer"));
var _Dot = _interopRequireDefault(require("../track/Dot"));
var _Dots = _interopRequireDefault(require("../track/Dots"));
var _Event = _interopRequireDefault(require("../track/Event"));
var _EventCustom = _interopRequireDefault(require("../track/EventCustom"));
var _EventCustomDefinition = _interopRequireDefault(require("../track/EventCustomDefinition"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ImporterCSV = exports["default"] = /*#__PURE__*/function (_Importer) {
  function ImporterCSV(fileName, fileData, customEventDefinitions) {
    var _this;
    _classCallCheck(this, ImporterCSV);
    _this = _callSuper(this, ImporterCSV, [fileName, fileData]);
    _this.customEventDefinitions = customEventDefinitions;
    _this.coordinateValidator = function (coordinate) {
      return coordinate.toString().match(/^(-?\d+(.\d+)?)$/);
    };
    _this.header = [];
    _this.FIELDS = {
      latitude: {
        aliases: ['latitude', 'lat', 'ypos'],
        required: true,
        validator: _this.coordinateValidator
      },
      longitude: {
        aliases: ['longitude', 'long', 'xpos', 'lng', 'lang', 'lon'],
        required: true,
        validator: _this.coordinateValidator
      },
      eventName: {
        aliases: ['event.name', 'EVT_NAME']
      },
      eventDesc: {
        aliases: ['event.desc', 'eventText', 'EVT_DESCR']
      },
      eventColor: {
        aliases: ['event.color', 'EVT_COLOR']
      },
      eventId: {
        aliases: ['EVT_ID']
      },
      eventType: {
        aliases: ['eventCode', 'EVT_TYPE']
      },
      eventDefault: {
        aliases: ['EVT_DEFAULT']
      }
    };
    _this.SEPARATORS = [',', ';'];
    _this._definitions = [];
    _this.TEXT_EVENT_ID = 1;
    _this.CUSTOM_EVENT_LOWER_LIMIT_OLD = 40000;
    _this.CUSTOM_EVENT_UPPER_LIMIT_OLD = 44999;
    _this.CUSTOM_EVENT_LOWER_LIMIT = 100000;
    _this.CUSTOM_EVENT_UPPER_LIMIT = 10000000;
    _this.EVENT_DEFINITION_LOWER_LIMIT = 50000;
    _this.EVENT_DEFINITION_UPPER_LIMIT = 60000;
    _this.DEFAULT_EVENT_COLOR = '#5c9eed';
    if (customEventDefinitions && customEventDefinitions.length > 0) {
      customEventDefinitions.forEach(function (customEventDefinition) {
        var definition = customEventDefinition.getDefinition();
        _this._definitions[definition.code] = definition;
      });
    }
    return _this;
  }
  _inherits(ImporterCSV, _Importer);
  return _createClass(ImporterCSV, [{
    key: "import",
    value: function _import() {
      var _this2 = this;
      var fileRows = this._fileData.split(/\r?\n/);
      var firstRow = fileRows.shift();
      var header = firstRow.split(new RegExp(this.SEPARATORS.join('|')));
      var rowSeparator = this.getCorrectRowSeparator(firstRow, header);
      var dots = new _Dots["default"]();
      fileRows.forEach(function (fileRow) {
        if (fileRow.trim().length === '' || fileRow.trim() === '' || fileRow.length === 0) return;
        // eslint-disable-next-line no-param-reassign
        fileRow = fileRow.split(rowSeparator);
        dots.add(new _Dot["default"](parseFloat(_this2.getField('latitude', header, fileRow)), parseFloat(_this2.getField('longitude', header, fileRow)), _this2.getEvent(header, fileRow)));
      });
      return dots;
    }
  }, {
    key: "getEvent",
    value: function getEvent(header, row) {
      if (!header) return '';
      var eventCode = this.getField('eventType', header, row);
      var eventText = this.getField('eventDesc', header, row);
      if (typeof eventCode !== 'undefined' && eventCode !== '' && typeof eventText !== 'undefined' && eventText !== '') {
        // eslint-disable-next-line max-len
        if (eventCode >= this.EVENT_DEFINITION_LOWER_LIMIT && eventCode <= this.EVENT_DEFINITION_UPPER_LIMIT) {
          return this.getEventCustomDefinition(eventCode, eventText, header, row);
          // eslint-disable-next-line max-len
        } else if (eventCode >= this.CUSTOM_EVENT_LOWER_LIMIT && eventCode <= this.CUSTOM_EVENT_UPPER_LIMIT || eventCode >= this.CUSTOM_EVENT_LOWER_LIMIT_OLD && eventCode <= this.CUSTOM_EVENT_UPPER_LIMIT_OLD) {
          return this.getEventCustom(eventCode, eventText, header, row);
        }
      }
      var id = this.getField('eventId', header, row);
      var name = this.getField('eventName', header, row);
      if (typeof id === 'undefined' || id === '') {
        id = eventCode;
      }
      if ((typeof id === 'undefined' || id === '') && (typeof name === 'undefined' || name === '')) {
        return undefined;
      }
      var description = this.getField('eventDesc', header, row);
      var matches;
      // eslint-disable-next-line camelcase
      var extracted_name;

      // eslint-disable-next-line no-cond-assign
      if ((matches = /.+?(?=: )/.exec(description)) !== null && matches.length > 0) {
        // eslint-disable-next-line camelcase
        extracted_name = matches[0];
        description = description.slice(extracted_name.length + 1).trim(); // name + ":"
      }
      var eventDefault = this.getIsDefaultEvent(id, header, row);

      // eslint-disable-next-line camelcase
      if (!name && extracted_name) {
        // eslint-disable-next-line camelcase
        name = extracted_name;
      } else if (!name && eventDefault) {
        name = description;
      }

      // Don't duplicate the name
      if (description === name) {
        description = '';
      }
      return new _Event["default"](parseInt(id, 10), name ? this.trimQuotes(name) : '', this.trimQuotes(description), this.getField('eventColor', header, row), eventDefault, true);
    }
  }, {
    key: "getIsDefaultEvent",
    value: function getIsDefaultEvent(id, header, row) {
      var eventDefault = this.getField('eventDefault', header, row);
      if (typeof eventDefault === 'undefined') {
        return parseInt(id, 10) !== this.TEXT_EVENT_ID;
      }
      return eventDefault.toString() === 'true';
    }
  }, {
    key: "getEventCustomDefinition",
    value: function getEventCustomDefinition(id, content, header, row) {
      // eslint-disable-next-line no-param-reassign
      content = JSON.parse(content);
      var color = this.getField('eventColor', header, row);
      color = typeof color !== 'undefined' ? color : this.DEFAULT_EVENT_COLOR;
      // this._definitions[content['code']] = content;

      var customDefinition = new _EventCustomDefinition["default"](parseInt(id, 10), color, content, true);
      if (!this._definitions.some(function (def) {
        return def._id === parseInt(id, 10);
      })) {
        this._definitions.push(customDefinition);
      }
      return customDefinition;
    }
  }, {
    key: "getEventCustom",
    value: function getEventCustom(id, content, header, row) {
      // var definition = this._definitions[id];

      // eslint-disable-next-line max-len
      var eventDefinition = this._definitions.find(function (def) {
        return parseInt(def._definition.code, 10) === parseInt(id, 10);
      });
      var definition;
      if (eventDefinition) {
        definition = eventDefinition._definition;
      }
      if (typeof definition === 'undefined') throw new Error("Can't find any definition for custom field with id #" + id);
      var undefinedRequiredFields = JSON.parse(JSON.stringify(definition.required));
      var markFieldAsFound = function markFieldAsFound(key) {
        var index = undefinedRequiredFields.indexOf(key);
        if (index !== -1) undefinedRequiredFields.splice(index, 1);
      };
      var getValue = function getValue(key, value) {
        if (!(key in definition.properties)) throw new Error('Field ' + key + ' has no defined properties');
        markFieldAsFound(key);

        // eslint-disable-next-line default-case
        switch (definition.properties[key].type) {
          case 'number':
          case 'float':
          case 'Number':
            return parseFloat(value);
          case 'integer':
          case 'Integer':
            return parseInt(value, 10);
          case 'string':
          case 'String':
            return value.toString();
          case 'boolean':
          case 'Boolean':
            return value.toString() === 'true';
        }
        return '';
      };
      var contentParsed = {};
      var foundProperties = [];
      var contentItems = content.split(',');
      contentItems.forEach(function (item) {
        // eslint-disable-next-line no-param-reassign
        item = item.split('=');
        if (item.length < 2) return;
        var key = item[0];
        var value = item[1];
        contentParsed[key] = getValue(key, value);
        foundProperties.push(key);
      });
      if (undefinedRequiredFields.length > 0) throw new Error('Required fields missing: ' + undefinedRequiredFields.join(', '));

      // eslint-disable-next-line max-len
      // Mark the not found (not required) fields as null (JSON friendly value, undefined gets discarded)
      // eslint-disable-next-line no-restricted-syntax
      for (var key in definition.properties) {
        // eslint-disable-next-line no-continue
        if (!(key in definition.properties) || foundProperties.indexOf(key) !== -1) continue;
        contentParsed[key] = null;
      }
      var color = this.getField('eventColor', header, row);
      color = typeof color !== 'undefined' ? color : this.DEFAULT_EVENT_COLOR;
      return new _EventCustom["default"](parseInt(id, 10), definition.title, contentParsed, color, true);
    }
  }, {
    key: "getField",
    value: function getField(field, header, row) {
      if (typeof header !== 'undefined' && typeof row !== 'undefined') {
        if (!(field in this.FIELDS)) throw new Error('Field ' + field + ' is not configured');
        var fieldIndex = -1;
        for (var i = 0; i <= this.FIELDS[field].aliases.length; i++) {
          var alias = this.FIELDS[field].aliases[i];
          fieldIndex = header.indexOf(alias);
          if (fieldIndex !== -1) break;
        }
        if (fieldIndex === -1 && this.FIELDS[field].required === true) throw new Error('Required field "' + field + '" not found in row');
        if (fieldIndex === -1 && this.FIELDS[field].required !== true) return undefined;
        if ('validator' in this.FIELDS[field] && !this.FIELDS[field].validator(row[fieldIndex])) throw new Error('Field "' + field + '" has an invalid value ' + row[fieldIndex]);
        return row[fieldIndex];
      }
      return 0;
    }
  }, {
    key: "getCorrectRowSeparator",
    value: function getCorrectRowSeparator(firstRow, header) {
      return this.SEPARATORS.find(function (separator) {
        return firstRow.split(separator).length === header.length;
      });
    }

    /**
     * Trims quotes and single quotes from a string
     *
     * @param {String} string
     * @returns {*}
     */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "trimQuotes",
    value: function trimQuotes(string) {
      var firstChar = string.charAt(0);
      var lastChar = string.charAt(string.length - 1);
      if (firstChar === '"' && lastChar === '"' || firstChar === "'" && lastChar === "'") {
        return string.substr(1, string.length - 2);
      }
      return string;
    }
  }]);
}(_Importer2["default"]);

},{"../track/Dot":9,"../track/Dots":10,"../track/Event":11,"../track/EventCustom":12,"../track/EventCustomDefinition":13,"./Importer":2}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ImporterCSV = _interopRequireDefault(require("./ImporterCSV"));
var _ImporterNMEA = _interopRequireDefault(require("./ImporterNMEA"));
var _ImporterXML = _interopRequireDefault(require("./ImporterXML"));
var _ImporterGPX = _interopRequireDefault(require("./ImporterGPX"));
var _ImporterKML = _interopRequireDefault(require("./ImporterKML"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ImporterFactory = exports["default"] = /*#__PURE__*/function () {
  function ImporterFactory(fileName, fileData, customEventDefinition) {
    _classCallCheck(this, ImporterFactory);
    this.fileName = fileName;
    this.fileData = fileData;
    this.customEventDefinition = customEventDefinition;
    var decomposedFileName = ImporterFactory._decomposeFileName(fileName);
    switch (decomposedFileName.extension) {
      case 'csv':
      default:
        return new _ImporterCSV["default"](fileName, fileData, customEventDefinition);
      case 'nmea':
        return new _ImporterNMEA["default"](fileName, fileData);
      case 'xml':
        return new _ImporterXML["default"](fileName, fileData);
      case 'gpx':
        return new _ImporterGPX["default"](fileName, fileData);
      case 'kml':
      case 'KML':
        return new _ImporterKML["default"](fileName, fileData);
    }
  }
  return _createClass(ImporterFactory, null, [{
    key: "_decomposeFileName",
    value: function _decomposeFileName(fileName) {
      // eslint-disable-next-line no-bitwise
      var extension = fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);
      return {
        name: fileName.replace('.' + extension, ''),
        extension: extension
      };
    }
  }]);
}();
if (typeof window !== 'undefined') window.ImporterFactory = ImporterFactory;
module.exports = ImporterFactory;

},{"./ImporterCSV":3,"./ImporterGPX":5,"./ImporterKML":6,"./ImporterNMEA":7,"./ImporterXML":8}],5:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Importer2 = _interopRequireDefault(require("./Importer"));
var _Dot = _interopRequireDefault(require("../track/Dot"));
var _Dots = _interopRequireDefault(require("../track/Dots"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ImporterGPX = exports["default"] = /*#__PURE__*/function (_Importer) {
  function ImporterGPX(fileName, fileData) {
    var _this;
    _classCallCheck(this, ImporterGPX);
    _this = _callSuper(this, ImporterGPX, [fileName, fileData]);
    _this.SEGMENTS_TAG = 'trkpt';
    return _this;
  }
  _inherits(ImporterGPX, _Importer);
  return _createClass(ImporterGPX, [{
    key: "import",
    value: function _import() {
      var dots = new _Dots["default"]();
      var file = this.parseFile();
      var segments = file.getElementsByTagName(this.SEGMENTS_TAG);
      for (var i = 0; i < segments.length; i++) {
        // dots is an object so it's always passed by reference in JS
        this.addDot(dots, segments[i]);
      }
      return dots;
    }
  }, {
    key: "parseFile",
    value: function parseFile() {
      var parser = new DOMParser();
      return parser.parseFromString(this._fileData, 'application/xml');
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "addDot",
    value: function addDot(dots, dotRow) {
      var lat = parseFloat(dotRow.getAttribute('lat'));
      var lon = parseFloat(dotRow.getAttribute('lon'));
      if (lat && lon) {
        dots.add(new _Dot["default"](lat, lon));
      } else {
        // eslint-disable-next-line no-console
        console.warn('Not completed data in row');
      }
    }
  }]);
}(_Importer2["default"]);

},{"../track/Dot":9,"../track/Dots":10,"./Importer":2}],6:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Importer2 = _interopRequireDefault(require("./Importer"));
var _Dot = _interopRequireDefault(require("../track/Dot"));
var _Dots = _interopRequireDefault(require("../track/Dots"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ImporterKML = exports["default"] = /*#__PURE__*/function (_Importer) {
  function ImporterKML(fileName, fileData) {
    var _this;
    _classCallCheck(this, ImporterKML);
    _this = _callSuper(this, ImporterKML, [fileName, fileData]);
    _this.SEGMENTS_TAG = 'coordinates';
    return _this;
  }
  _inherits(ImporterKML, _Importer);
  return _createClass(ImporterKML, [{
    key: "import",
    value: function _import() {
      var dots = new _Dots["default"]();
      var file = this.parseFile();
      var segments;
      var segmentsArr;
      var usesPoints = false;
      if (file.getElementsByTagName('Point').length > 0) {
        segments = file.getElementsByTagName('Point');
        segmentsArr = segments;
        usesPoints = true;
      } else {
        segments = file.getElementsByTagName(this.SEGMENTS_TAG)[0];
        segmentsArr = segments.innerHTML.split('\n');
      }
      var error = file.getElementsByTagName('parsererror')[0];
      if (error) throw new Error(error.getElementsByTagName('div')[0].innerHTML);
      var oldDot;
      var newDot;
      for (var i = 0; i < segmentsArr.length; i++) {
        if (segmentsArr[i].toString().trim().length === 0) {
          // eslint-disable-next-line no-console
          console.warn('Zero length line, skipping');
          // eslint-disable-next-line no-continue
          continue;
        }
        // dots is an object so it's always passed by reference in JS
        var coords = void 0;
        if (usesPoints) {
          coords = segmentsArr[i].firstElementChild.innerHTML.toString().trim().split(',');
        } else {
          coords = segmentsArr[i].toString().trim().split(',');
        }
        if (coords[0] && coords[1]) {
          newDot = new _Dot["default"](parseFloat(coords[1]), parseFloat(coords[0]));
          // eslint-disable-next-line max-len
          if (oldDot && oldDot.getLatitude() !== newDot.getLatitude() && oldDot.getLongitude() !== newDot.getLongitude()) {
            dots.add(newDot);
          } else if (!oldDot && newDot) {
            dots.add(newDot);
          }
          oldDot = newDot;
        } else {
          // eslint-disable-next-line no-console
          console.warn(segmentsArr[i]);
          throw new Error('Malformed file');
        }
      }
      return dots;
    }
  }, {
    key: "parseFile",
    value: function parseFile() {
      var parser = new DOMParser();
      return parser.parseFromString(this._fileData, 'application/xml');
    }
  }]);
}(_Importer2["default"]);

},{"../track/Dot":9,"../track/Dots":10,"./Importer":2}],7:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Importer2 = _interopRequireDefault(require("./Importer"));
var _Dot = _interopRequireDefault(require("../track/Dot"));
var _Dots = _interopRequireDefault(require("../track/Dots"));
var _Event = _interopRequireDefault(require("../track/Event"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ImporterNMEA = exports["default"] = /*#__PURE__*/function (_Importer) {
  function ImporterNMEA(fileName, fileData) {
    var _this;
    _classCallCheck(this, ImporterNMEA);
    _this = _callSuper(this, ImporterNMEA, [fileName, fileData]);
    _this.ROW_SEPARATOR = '$';
    _this.ROW_HEADER_DOT = 'GPRMC';
    _this.ROW_HEADER_EVENT = 'IWEVENT';
    _this.ROW_DOT_INDEXES = {
      HEADER: 0,
      SIGN_NORTH: 4,
      VALUE_NORTH: 3,
      SIGN_EAST: 6,
      VALUE_EAST: 5,
      EVENT_ID: 1,
      EVENT_NAME: 2,
      EVENT_LATITUDE: 4,
      EVENT_LONGITUDE: 3
    };
    return _this;
  }
  _inherits(ImporterNMEA, _Importer);
  return _createClass(ImporterNMEA, [{
    key: "import",
    value: function _import() {
      var _this2 = this;
      var fileRows = this._fileData.split(this.ROW_SEPARATOR);
      if (fileRows.length < 2) throw new Error('Not enough points in NMEA file to create a track');
      var dots = new _Dots["default"]();
      fileRows.forEach(function (row) {
        // eslint-disable-next-line no-param-reassign
        if (row.length === 0 || typeof row === 'undefined') return;
        row = row.trim().split(',');

        // eslint-disable-next-line default-case
        switch (row[_this2.ROW_DOT_INDEXES.HEADER]) {
          // eslint-disable-next-line no-case-declarations
          case _this2.ROW_HEADER_DOT:
            var dot = _this2.getDot(row);
            if (dot) {
              dots.add(_this2.getDot(row));
            }
            break;
          case _this2.ROW_HEADER_EVENT:
            dots.add(_this2.getEventDot(row));
            break;
        }
      });
      return dots;
    }
  }, {
    key: "getDot",
    value: function getDot(row) {
      if (typeof row === 'undefined') return;
      var sign;
      var latitude = 0;
      var longitude = 0;
      sign = row[this.ROW_DOT_INDEXES.SIGN_NORTH] === 'N' ? 1 : -1;
      if (row[this.ROW_DOT_INDEXES.VALUE_NORTH].length > 3) {
        // eslint-disable-next-line max-len
        latitude = sign * (parseInt(row[this.ROW_DOT_INDEXES.VALUE_NORTH].substring(0, 2), 10) + parseFloat(row[this.ROW_DOT_INDEXES.VALUE_NORTH].substring(2)) / 60);
      }
      sign = row[this.ROW_DOT_INDEXES.SIGN_EAST] === 'E' ? 1 : -1;
      if (row[this.ROW_DOT_INDEXES.VALUE_EAST].length > 3) {
        // eslint-disable-next-line max-len
        longitude = sign * (parseInt(row[this.ROW_DOT_INDEXES.VALUE_EAST].substring(0, 3), 10) + parseFloat(row[this.ROW_DOT_INDEXES.VALUE_EAST].substring(3)) / 60);
      }
      var dot = null;
      if (latitude !== 0 && longitude !== 0) {
        dot = new _Dot["default"](latitude, longitude);
      }
      return dot;
    }
  }, {
    key: "getEventDot",
    value: function getEventDot(row) {
      if (typeof row === 'undefined') return null;
      var eventName = row[this.ROW_DOT_INDEXES.EVENT_NAME];
      if (eventName.charAt(0) === "'" && eventName.charAt(eventName.length - 1) === "'") eventName = eventName.substr(1, eventName.length - 2);
      var description = '';
      var matches;
      // eslint-disable-next-line camelcase
      var extracted_name;

      // eslint-disable-next-line no-cond-assign
      if ((matches = /.+?(?=: )/.exec(eventName)) !== null && matches.length > 0) {
        // eslint-disable-next-line camelcase
        extracted_name = matches[0];
        description = eventName.slice(extracted_name.length + 1).trim(); // name + ":"
      }
      var eventDefault = row[this.ROW_DOT_INDEXES.EVENT_ID] !== 1;

      // eslint-disable-next-line camelcase
      if (extracted_name) {
        // eslint-disable-next-line camelcase
        eventName = extracted_name;
      }
      if (!eventName && eventDefault) {
        eventName = description;
      }

      // Don't duplicate the name
      if (description === eventName) {
        description = '';
      }
      return new _Dot["default"](parseFloat(row[this.ROW_DOT_INDEXES.EVENT_LATITUDE]), parseFloat(row[this.ROW_DOT_INDEXES.EVENT_LONGITUDE]), new _Event["default"](parseInt(row[this.ROW_DOT_INDEXES.EVENT_ID], 10), eventName, description, '#FFF', parseInt(row[this.ROW_DOT_INDEXES.EVENT_ID], 10) !== 1, true));
    }
  }]);
}(_Importer2["default"]);

},{"../track/Dot":9,"../track/Dots":10,"../track/Event":11,"./Importer":2}],8:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Importer2 = _interopRequireDefault(require("./Importer"));
var _Dot = _interopRequireDefault(require("../track/Dot"));
var _Dots = _interopRequireDefault(require("../track/Dots"));
var _Event = _interopRequireDefault(require("../track/Event"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ImporterXML = exports["default"] = /*#__PURE__*/function (_Importer) {
  function ImporterXML(fileName, fileData) {
    var _this;
    _classCallCheck(this, ImporterXML);
    _this = _callSuper(this, ImporterXML, [fileName, fileData]);
    _this.SEGMENTS_TAG = 'tache';
    _this.EVENTS_MAPPING = {
      0: {
        id: 65542,
        name: 'Both sides'
      },
      1: {
        id: 65540,
        name: 'Right side'
      },
      2: {
        id: 65541,
        name: 'Left side'
      },
      3: {
        id: 65540,
        name: 'Right side'
      },
      4: {
        id: 65542,
        name: 'Both sides'
      },
      5: {
        id: 65539,
        name: 'Transfer'
      },
      6: {
        id: 65552,
        name: 'Backwards'
      }
    };
    return _this;
  }
  _inherits(ImporterXML, _Importer);
  return _createClass(ImporterXML, [{
    key: "import",
    value: function _import() {
      var dots = new _Dots["default"]();
      var latestAddedEvent = {
        name: ''
      };
      var file = this.parseFile();
      var segments = file.getElementsByTagName(this.SEGMENTS_TAG);
      for (var i = 0; i < segments.length; i++) {
        // dots is an object so it's always passed by reference in JS
        this.addPoints(dots, segments[i], latestAddedEvent);
      }
      return dots;
    }
  }, {
    key: "addPoints",
    value: function addPoints() {
      var dots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var segment = arguments.length > 1 ? arguments[1] : undefined;
      var latestAddedEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (segment !== 'undefined') {
        var points = segment.getElementsByTagName('point');
        for (var i = 0; i < points.length; i++) {
          var event = void 0;
          if (i === 0) {
            var eventName = this.getStartEventName(segment.getAttribute('typecollecte'));
            if (eventName !== latestAddedEvent.name) {
              // eslint-disable-next-line no-param-reassign
              latestAddedEvent.name = eventName;
              event = this.getStartEvent(segment);
            }
          }
          dots.add(new _Dot["default"](parseFloat(points[i].getAttribute('Latitude')), parseFloat(points[i].getAttribute('Longitude')), event));
        }
      }
    }
  }, {
    key: "parseFile",
    value: function parseFile() {
      var parser = new DOMParser();
      return parser.parseFromString(this._fileData, 'application/xml');
    }
  }, {
    key: "getStartEvent",
    value: function getStartEvent(segment) {
      return new _Event["default"](this.getStartEventId(segment.getAttribute('typecollecte')), this.getStartEventName(segment.getAttribute('typecollecte')), '', '#FFF', true, true);
    }
  }, {
    key: "getStartEventId",
    value: function getStartEventId(eventId) {
      return this.EVENTS_MAPPING[eventId].id;
    }
  }, {
    key: "getStartEventName",
    value: function getStartEventName(eventId) {
      return this.EVENTS_MAPPING[eventId].name;
    }
  }]);
}(_Importer2["default"]);

},{"../track/Dot":9,"../track/Dots":10,"../track/Event":11,"./Importer":2}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _FollowMeUtils = _interopRequireDefault(require("../FollowMeUtils"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dot = exports["default"] = /*#__PURE__*/function () {
  function Dot(latitude, longitude, event) {
    _classCallCheck(this, Dot);
    this._latitude = latitude;
    this._longitude = longitude;
    this._event = event;
    this._marker = null;
    this._markerEvent = null;
  }
  return _createClass(Dot, [{
    key: "setLatitude",
    value: function setLatitude(latitude) {
      this._latitude = latitude;
      this._updateInheritedFields(this._event);
    }
  }, {
    key: "setLongitude",
    value: function setLongitude(longitude) {
      this._longitude = longitude;
      this._updateInheritedFields(this._event);
    }
  }, {
    key: "setEvent",
    value: function setEvent(event) {
      this._updateInheritedFields(event);
      this._event = event;
      window.followmeMap.buildDotTable();
    }
  }, {
    key: "setEventFromTable",
    value: function setEventFromTable(event) {
      this._updateInheritedFields(event);
      this._event = event;
    }
  }, {
    key: "setMarker",
    value: function setMarker(marker) {
      this._marker = marker;
    }
  }, {
    key: "setMarkerEvent",
    value: function setMarkerEvent(markerEvent) {
      this._markerEvent = markerEvent;
    }
  }, {
    key: "getLatitude",
    value: function getLatitude() {
      return this._latitude;
    }
  }, {
    key: "getLongitude",
    value: function getLongitude() {
      return this._longitude;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      // eslint-disable-next-line no-undef
      return new IWCoordinate(this._longitude, this._latitude, IWCoordinate.WGS84);
    }
  }, {
    key: "getEvent",
    value: function getEvent() {
      return this._event;
    }
  }, {
    key: "getMarker",
    value: function getMarker() {
      return this._marker;
    }
  }, {
    key: "getMarkerEvent",
    value: function getMarkerEvent() {
      return this._markerEvent;
    }
  }, {
    key: "getHash",
    value: function getHash() {
      return _FollowMeUtils["default"].hashString(this._latitude.toString() + this._longitude.toString() + JSON.stringify(this._event));
    }
  }, {
    key: "isDrawable",
    value: function isDrawable() {
      return typeof this._event === 'undefined' || this._event.constructor.name !== 'EventCustomDefinition';
    }
  }, {
    key: "hasEvent",
    value: function hasEvent() {
      return typeof this._event !== 'undefined';
    }
  }, {
    key: "hasMarkerEvent",
    value: function hasMarkerEvent() {
      return this._markerEvent !== null && typeof this._markerEvent !== 'undefined';
    }
  }, {
    key: "hasMarker",
    value: function hasMarker() {
      return this._marker !== null && typeof this._marker !== 'undefined';
    }
  }, {
    key: "clearEvent",
    value: function clearEvent() {
      this._event = undefined;
    }
  }, {
    key: "clearMarker",
    value: function clearMarker() {
      this._marker = null;
    }
  }, {
    key: "clearMarkerEvent",
    value: function clearMarkerEvent() {
      this._markerEvent = null;
    }
  }, {
    key: "_updateInheritedFields",
    value: function _updateInheritedFields(event) {
      if (!event || event.constructor.name !== 'EventCustom') return;
      var content = event.getContent();

      // eslint-disable-next-line no-restricted-syntax
      for (var item in content) {
        // eslint-disable-next-line no-continue
        if (!(item in content)) continue;
        if (['latitude', 'lat'].indexOf(item.toLowerCase()) !== -1) content[item] = this.getLatitude();
        if (['longitude', 'long', 'lng', 'lon'].indexOf(item.toLowerCase()) !== -1) content[item] = this.getLongitude();
      }
    }
  }]);
}();
module.exports = Dot;

},{"../FollowMeUtils":1}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dots = exports["default"] = /*#__PURE__*/function () {
  function Dots() {
    _classCallCheck(this, Dots);
    this._dots = [];
    this._definitions = {};
  }
  return _createClass(Dots, [{
    key: "add",
    value: function add(dot) {
      this._dots.push(dot);
      this.addDotDefinition(dot);
    }
  }, {
    key: "addAtIndex",
    value: function addAtIndex(index, dot) {
      this._dots.splice(index, 0, dot);
      this.addDotDefinition(dot);
      if (typeof window !== 'undefined') {
        window.followmeMap.buildDotTable();
      }
    }
  }, {
    key: "popDotDefinitions",
    value: function popDotDefinitions() {
      var definitions = [];
      var dots = [];
      this._dots.forEach(function (dot) {
        if (!dot.hasEvent() || dot.getEvent().constructor.name !== 'EventCustomDefinition') {
          dots.push(dot);
          return;
        }
        definitions.push(dot.getEvent());
      });
      this._dots = dots;
      return definitions;
    }
  }, {
    key: "addDotDefinition",
    value: function addDotDefinition(dot) {
      if (!dot.hasEvent() || dot.getEvent().constructor.name !== 'EventCustomDefinition') return;
      var eventCode = parseInt(dot.getEvent().getDefinition().code, 10);
      this._definitions[eventCode] = dot.getEvent();
    }
  }, {
    key: "getTotal",
    value: function getTotal() {
      return this._dots.length;
    }
  }, {
    key: "getTotalVisible",
    value: function getTotalVisible() {
      return this._dots.filter(function (dot) {
        return dot.isDrawable();
      }).length;
    }
  }, {
    key: "get",
    value: function get() {
      return this._dots;
    }
  }, {
    key: "getByEventCustomDefinitionCode",
    value: function getByEventCustomDefinitionCode(code) {
      for (var i = 0; i < this._dots.length; i++) {
        if (this._dots[i].hasEvent() && this._dots[i].getEvent().constructor.name === 'EventCustomDefinition' && this._dots[i].getEvent().getDefinition().code === code) {
          return this._dots[i];
        }
      }
      return null;
    }
  }, {
    key: "refreshDefinitions",
    value: function refreshDefinitions() {
      this._definitions = {};
      for (var i = 0; i < this._dots.length; i++) {
        if (this._dots[i].hasEvent() && this._dots[i].getEvent().constructor.name === 'EventCustomDefinition') {
          var eventCode = parseInt(this._dots[i].getEvent().getDefinition().code, 10);
          this._definitions[eventCode] = this._dots[i].getEvent();
        }
      }
    }
  }, {
    key: "getDefinitions",
    value: function getDefinitions() {
      return this._definitions;
    }
  }, {
    key: "getByIndex",
    value: function getByIndex(index) {
      return this._dots[index];
    }
  }, {
    key: "deleteDots",
    value: function deleteDots(dotsIndexesToDelete) {
      this._dots = this._dots.filter(function (dot, index) {
        return dotsIndexesToDelete.indexOf(index) === -1;
      });
    }
  }, {
    key: "replaceWith",
    value: function replaceWith(dots) {
      var _this = this;
      this._dots = [];
      dots.forEach(function (dot) {
        _this._dots.push(dot);
      });
    }
  }]);
}();
module.exports = Dots;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Event = exports["default"] = /*#__PURE__*/function () {
  function Event(id, name, description, color, isDefault, isDrawable) {
    _classCallCheck(this, Event);
    this._id = id;
    this._name = name;
    this._description = description;
    this._color = color;
    this._isDefault = isDefault;
    this._isDrawable = isDrawable;
  }
  return _createClass(Event, [{
    key: "setIsDrawable",
    value: function setIsDrawable(isDrawable) {
      this._isDrawable = isDrawable;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this._description;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
  }, {
    key: "getIsDefault",
    value: function getIsDefault() {
      return this._isDefault;
    }
  }, {
    key: "getIsEditable",
    value: function getIsEditable() {
      return !this._isDefault || this._id >= 45000 && this._id < 46000;
    }
  }, {
    key: "getIsDrawable",
    value: function getIsDrawable() {
      return this._isDrawable;
    }
  }]);
}();
module.exports = Event;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventCustom = exports["default"] = /*#__PURE__*/function () {
  function EventCustom(id, name, content, color, isDrawable) {
    _classCallCheck(this, EventCustom);
    this._id = id;
    this._name = name;
    this._content = content;
    this._color = color;
    this._isDrawable = isDrawable;
  }
  return _createClass(EventCustom, [{
    key: "setIsDrawable",
    value: function setIsDrawable(isDrawable) {
      this._isDrawable = isDrawable;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "getContent",
    value: function getContent() {
      return this._content;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
  }, {
    key: "getIsDrawable",
    value: function getIsDrawable() {
      return this._isDrawable;
    }
  }], [{
    key: "getIsEditable",
    value: function getIsEditable() {
      return true;
    }
  }]);
}();
module.exports = EventCustom;

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventCustomDefinition = exports["default"] = /*#__PURE__*/function () {
  function EventCustomDefinition(id, color, definition, isDrawable) {
    _classCallCheck(this, EventCustomDefinition);
    this._id = id;
    this._color = color;
    this._definition = definition;
    this._isDrawable = isDrawable;
  }
  return _createClass(EventCustomDefinition, [{
    key: "setIsDrawable",
    value: function setIsDrawable(isDrawable) {
      this._isDrawable = isDrawable;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
  }, {
    key: "getDefinition",
    value: function getDefinition() {
      return this._definition;
    }
  }, {
    key: "getIsDrawable",
    value: function getIsDrawable() {
      return this._isDrawable;
    }
  }], [{
    key: "getIsEditable",
    value: function getIsEditable() {
      return false;
    }
  }]);
}();
if (typeof window !== 'undefined') window.EventCustomDefinition = EventCustomDefinition;
module.exports = EventCustomDefinition;

},{}]},{},[4])

